import { AssetfiAssetType } from '@/types/asset-type';

export default function UserFiledSvg({ width = 24, height = 24 }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 19V17.75C18 15.6789 16.0812 14 13.7143 14H10.2857C7.91878 14 6 15.6789 6 17.75V19M15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8Z"
        stroke="#357AFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
